import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (typeof window !== 'undefined') {
      // Load Meta Pixel script
      ;
      (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        // Check if script tag exists, otherwise append to head
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          b.head.appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      // Initialize with Pixel ID
      window.fbq('init', '877859571789557');
      // Track PageView
      window.fbq('track', 'PageView');
    }
  }, []);
  return <>
      {/* Noscript fallback */}
      <noscript data-id="element-145">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=877859571789557&ev=PageView&noscript=1" alt="" data-id="element-146" />
      </noscript>
    </>;
}
// Helper function to track AddToCart event
export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Sistema de Optimización Crediticia',
      content_ids: ['48538406093043'],
      content_type: 'product',
      value: 6.36,
      currency: 'USD'
    });
  }
}